<mds-dialog [dialogTitle]="'Potential Duplicates'">
    <mds-dialog-content>
        <div class="flex flex-col gap-medpace">
            <p>
                @if (hasMoreThanOneDuplicate()) {
                    The following requests will become duplicates after your changes. Select the ones you still want to
                    proceed with:
                } @else {
                    The following request will become duplicate after your changes. Click Continue (button) to proceed.
                }
            </p>
            <div class="duplicate-list flex flex-col gap-2">
                @for (duplicate of data().potentialDuplicates; track duplicate.expenseId; let i = $index) {
                    <div class="duplicate-item flex flex-row items-center justify-between p-2 border rounded">
                        <div class="flex flex-col">
                            <h5 class="pb-2 subtitle">
                                {{ duplicate.requestType }} Request
                                <a [href]="getEditRoute(duplicate)" target="_blank" rel="noopener noreferrer">
                                    {{ getPrefix(duplicate.requestType) }}-{{ duplicate.requestId }}
                                </a>
                            </h5>
                            <span class="body"
                                >{{
                                    'Visit Name: ' +
                                        (duplicate.visitName ?? 'N/A') +
                                        ' | ' +
                                        'Visit Date: ' +
                                        (duplicate.visitDate | dateFormat: undefined : 'local')
                                }}
                            </span>
                        </div>
                        @if (hasMoreThanOneDuplicate()) {
                            <mds-checkbox [checked]="selectedItems().has(i)" (changeEvent)="toggleItem(i)" />
                        }
                    </div>
                }
            </div>
        </div>
    </mds-dialog-content>

    <mds-dialog-actions [align]="'end'">
        <div class="flex flex-row gap-medpace">
            <mds-button
                [id]="'cancel-btn'"
                [label]="'Cancel'"
                variant="outline"
                [color]="'neutral'"
                (clickEvent)="cancel()"
            />
            @if (hasMoreThanOneDuplicate()) {
                <mds-button
                    [id]="'confirm-btn'"
                    [label]="'Continue with selected'"
                    [variant]="'filled'"
                    [color]="'primary'"
                    [disabled]="!hasSelection()"
                    (clickEvent)="confirm()"
                />
            } @else {
                <mds-button
                    [id]="'confirm-btn'"
                    [label]="'Continue'"
                    [color]="'primary'"
                    [variant]="'filled'"
                    [disabled]="false"
                    (clickEvent)="confirm()"
                />
            }
        </div>
    </mds-dialog-actions>
</mds-dialog>
